import { spawn } from 'redux-saga/effects';

import { watchGetBooks } from './getBooks';

export default function* saga() {
  yield spawn(watchGetBooks);
}
